<template>
    <div class="right" :class="direction">
        <div class="manipulate-stamps-container">
            <form action="/passport/stamp" method="post" @submit="loading = true" :disabled="!amount || !confirming">
                <div v-show="!confirming">
                    <csrf></csrf>
                    <input type="hidden" name="direction" :value="direction">
                    <input type="hidden" name="amount" :value="amount">
                    <a href @click.prevent="swap" class="add-or-subtract">{{ direction.toUpperCase() }} STAMPS <span class="fa fa-retweet"></span></a>
                    <the-mask type="text" name="value" v-model="amount" :mask="mask" required />
                    <button v-if="amount > 0" @click.prevent="confirming = true" type="submit" style="text-transform:uppercase;">{{ maskPrefix }}{{ amount }} {{ direction === 'add' ? 'to' : 'from' }} <person-name :model="child" :plural="true"></person-name> BALANCE</button>
                    <button v-else>PROVIDE AN AMOUNT TO {{ direction.toUpperCase() }}</button>
                </div>
                <div v-show="confirming">
                    <button v-if="!loading" type="submit">{{ direction }} {{ maskPrefix + amount }} {{ amount != 1 ? 'stamps' : 'stamp' }} {{ direction === 'add' ? 'to' : 'from' }} <person-name :model="child" :plural="true"></person-name> account now</button>
                    <button v-if="loading" type="submit">Processing...</button>
                    <button @click.prevent="confirming = false">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>

export default {

    props: [ 'child', 'balance' ],

    data() {
        return {
            loading: false,
            direction: 'add',
            amount: 1,
            confirming: false,
        };
    },

    computed: {

        maskPrefix() {
            return this.direction !== 'add' ? '-' : '+';
        },

        mask() {
            return this.maskPrefix + '#####';
        }
    },

    watch: {

        amount(newValue) {
            if (this.direction === 'subtract' && parseInt(newValue) > this.balance) {
                this.amount = this.balance;
            }
        },

    },

    methods: {

        swap() {
            if (this.direction === 'add') {
                this.direction = 'subtract';
                if (this.amount > this.balance) {
                    this.amount = this.balance;
                }
            } else {
                this.direction = 'add';
            }
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/passport/AddStamps.vue